import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=6d39c1d8"
import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"
import style0 from "./Col.vue?vue&type=style&index=0&id=6d39c1d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports